// this is an autogenerated file from App/Account/Content/Calendar/New/AppointmentOverlay/Content/New/NextAppointment/Content/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__App_Account_Content_Calendar_New_AppointmentOverlay_Content_New_NextAppointment_Content($patient_id: uuid!, $ignored_booking_ids: _uuid!) {
  appointments_upcoming_appointment_bookings_by_patient(
    args: { patient_id: $patient_id, ignored_booking_ids: $ignored_booking_ids }
  ) {
    _id
    state
    local_start_date
    local_start_time
    duration
    location {
      id
      _id
      name
      time_zone_id
    }
    appointment {
      _id
      type {
        _id
        display_name
        display_color_id
      }
      tx {
        _id
      }
    }
    chair {
      _id
      full_name
    }
  }
}

`